import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

// completed: completó la postulación que le creó el reclutador (2026-10-08)
const PortalSuccessScreen = ({ position, fairHref = null, pendingValidation = false, completed = false }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', px: 2 }}>
      <Box sx={{ width: '100%', maxWidth: 480 }}>

        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Box
            component="img"
            src="/amandalogoh.png"
            alt="Amanda HR"
            sx={{ height: 40, mb: 3 }}
          />
        </Box>

        <Paper elevation={0} sx={{ border: '1px solid #E5E7EB', borderRadius: 2, p: 4, textAlign: 'center' }}>
          <CheckCircleOutlineIcon sx={{ fontSize: 64, color: '#22C55E', mb: 2 }} />

          <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
            {completed ? t('portal.completeApplication.doneTitle') : t('portal.successTitle')}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {/* "Por validar" (PLAN_IMPORTACION_COMPUTRABAJO, fase 0): un
                reclutador revisará sus datos antes de continuar */}
            {completed
              ? t('portal.completeApplication.doneMessage', { position: position?.name || '' })
              : pendingValidation
                ? t('portal.successPendingMessage', { position: position?.name || '' })
                : position
                  ? t('portal.successMessagePosition', { position: position.name })
                  : t('portal.successMessage')
            }
          </Typography>

          {/* Desde una feria: volver a sus vacantes para postular a otra (PLAN_FERIAS) */}
          {fairHref && (
            <Button
              variant="contained"
              fullWidth
              href={fairHref}
              sx={{ mt: 3, backgroundColor: '#6A5AF9', '&:hover': { backgroundColor: '#5B4DE8' }, py: 1.5 }}
            >
              {t('portal.fair.backToFair')}
            </Button>
          )}
        </Paper>

      </Box>
    </Box>
  );
};

export default PortalSuccessScreen;